module.exports = __webpack_public_path__ + "static/media/katie.fc64e5db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupDesigners/assets/katie.jpg
// module id = 537
// module chunks = 0